import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-39486c3b")

_pushScopeId("data-v-39486c3b")
const _hoisted_1 = { class: "policy-container background-white" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.policyComponent), {
      "form-data": _ctx.formData,
      class: "privacy-policy"
    }, null, 8, ["form-data"]))
  ]))
})